import React, { useState } from "react";
import styled from "styled-components";
import { MenuTab } from "./MenuTab";
import { Link } from "react-router-dom";

import FamilySite from "./FamilySiteTab";
import useIsMobile from "@/hooks/useIsMobile";

const Header = () => {
  const [tab, setTab] = useState("");
  const isMobile = useIsMobile();
  return (
    <>
      <MenubarContainer className="menubar" $ismobile={isMobile}>
        <Link
          style={{
            all: "unset"
          }}
          to="/"
          onClick={() => setTab("")}
        >
          <LogoWrapper>
            <img id="logo" src="/static/maintype_3.png" alt="logo" />
            <Subtitle>OOSI</Subtitle>
          </LogoWrapper>
        </Link>
        <FamilySite />
        <MenuTab tab={tab} setTab={setTab} />
      </MenubarContainer>
      {/* <Divider /> */}
    </>
  );
};

export default Header;

const MenubarContainer = styled.header`
  width: 100%;
  /* min-width: 700px; */
  min-height: 5rem;
  padding: 0 3rem;

  z-index: 10;
  box-sizing: border-box;

  display: flex;
  justify-content: ${props =>
    props.$ismobile ? "space-between" : "flex-start"};
  align-items: center;

  flex-wrap: wrap;
  gap: 1rem;
  /* @media screen and (max-width: 546px) {
    flex-direction: column;
  } */
`;

const Divider = styled.div`
  width: auto;
  border-top: 2px solid #4b5761;
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 15rem;
  padding: 1rem 0 0 0;
  gap: 0.3rem;

  > #logo {
    width: 100%;
    height: auto;
  }
  @media screen and (max-width: 300px) {
    width: 10rem;
  }
`;

const Subtitle = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  color: #e7c11d;
`;
